import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import useActiveMenu from "./useActiveMenu";

const API = "https://admin.bridge365.in/wp-json/wc/v3";
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

function decodeHtmlEntities(text = "") {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

function Mobilemenu() {
  const [categories, setCategories] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const location = useLocation();
  const { isHomeActive, isCategoryActive, isExactCategoryActive } = useActiveMenu(categories);

  useEffect(() => {
    fetch(`${API}/products/categories?per_page=100&consumer_key=${CK}&consumer_secret=${CS}`)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setCategories(
          list
            .filter((cat) => cat.slug !== "uncategorized" && cat.name?.toLowerCase() !== "uncategorized")
            .map((cat) => ({ ...cat, name: decodeHtmlEntities(cat.name) }))
        );
      })
      .catch(() => setCategories([]));
  }, []);

  const parentCats = categories.filter((cat) => cat.parent === 0);
  const getSubCats = (parentId) => categories.filter((cat) => cat.parent === parentId);

  useEffect(() => {
    const activeParent = parentCats.find((parent) => isCategoryActive(parent.id));
    setOpenMenuId(activeParent ? activeParent.id : null);
  }, [location.pathname, categories]);

  const toggleMenu = (event, parentId) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenMenuId((current) => (current === parentId ? null : parentId));
  };

  return (
    <nav className="navbar-mobile">
      <ul className="mobile-nav-list">
        <li className={`mobile-nav-item${isHomeActive ? " active" : ""}`}>
          <div className="mobile-nav-row">
            <NavLink className={`mobile-nav-link${isHomeActive ? " active" : ""}`} to="/home">
              Home
            </NavLink>
          </div>
        </li>

        {parentCats.map((parent) => {
          const subCats = getSubCats(parent.id);
          const hasSubCats = subCats.length > 0;
          const isOpen = openMenuId === parent.id;

          return (
            <li
              key={parent.id}
              className={`mobile-nav-item${isCategoryActive(parent.id) ? " active" : ""}${
                isOpen ? " is-open" : ""
              }`}
            >
              <div className="mobile-nav-row">
                <Link
                  className={`mobile-nav-link${isCategoryActive(parent.id) ? " active" : ""}`}
                  to={`/category/${parent.id}`}
                >
                  {parent.name}
                </Link>

                {hasSubCats && (
                  <button
                    type="button"
                    className={`mobile-nav-toggle${isOpen ? " is-open" : ""}`}
                    aria-expanded={isOpen}
                    aria-label={`Toggle ${parent.name} submenu`}
                    onClick={(event) => toggleMenu(event, parent.id)}
                  >
                    <FiChevronDown />
                  </button>
                )}
              </div>

              {hasSubCats && (
                <ul className={`mobile-submenu${isOpen ? " is-open" : ""}`}>
                  {subCats.map((sub) => (
                    <li key={sub.id}>
                      <Link
                        className={`mobile-submenu-link${
                          isExactCategoryActive(sub.id) ? " active" : ""
                        }`}
                        to={`/category/${sub.id}`}
                      >
                        {sub.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Mobilemenu;
